<template>
  <div>
    <div id="container" style="width: 100%;height: 200px"></div>
    <div class="filds">
      <van-field v-model="addr" label="地点" label-width="50" placeholder="地点" :readonly="(dispalyone || loading)" />
      <van-field v-model="longitude" label="经度" label-width="50" placeholder="经度" readonly />
      <van-field v-model="latitude" label="纬度" label-width="50" placeholder="'纬度" readonly />
    </div>
    <div class="filds">
      <div style="color:#666;font-size: 16px;padding: 3px 15px;">照片(最多9张)</div>
      <div class="paddingXm">
        <van-uploader :max-count="9" v-model="images" :disabled="(dispalyone || loading)"
          :deletable="(!dispalyone && !loading)" multiple :after-read="afterRead" @delete="deleteImg"
          :show-upload="(!dispalyone && !loading)" />
      </div>
    </div>
    <div class="filds">
      <van-field v-model="remark" label-width="50" rows="4" autosize label="备注" type="textarea" maxlength="200"
        placeholder="请输入留言" show-word-limit :readonly="(dispalyone || loading)" />
    </div>
    <div style="height: 60px;"></div>
    <div class="footers" v-show="!dispalyone">
      <div class="buttons" @click="save()" :style="{
        'pointer-events': loading ? 'none' : ''
      }"> 保存</div>
    </div>
    <van-loading v-show="loading" type="spinner" color="#1989fa"
      style=" position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);" />
  </div>
</template>
<script>
import lrz from 'lrz'
import { Dialog, Toast, Loading } from 'vant'
export default {
  name: 'mapLoading',
  data () {
    return {
      latitude: '',
      longitude: '',
      id: '',
      addr: '',
      artical_id: '',
      images: [],
      images2: [],
      remark: '',
      dispalyone: false,
      type: '',
      loading: false
    }
  },
  created () {
    this.id = this.$route.query.id
    this.artical_id = this.$route.query.artical_id
    this.type = this.$route.query.type

    if (this.id && this.type === 'readonly') {
      this.getInfo()
      this.dispalyone = true

    } else if (this.artical_id && this.type === 'add') {
      this.dispalyone = false

    }



  },
  mounted () {
    if (this.type === 'add') {
      this.getLocation()
    }

  },
  methods: {
    getInfo () {
      let that = this
      this.images = []
      this.$axios.get('/caidian/item-view', {
        params: {
          id: this.id
        }
      }).then(res => {
        let data = res.data.data
        this.addr = data.addr
        this.latitude = data.latitude
        this.longitude = data.longitude
        this.remark = data.remark
        if (data.pics) {
          let pics = data.pics.split(',')
          for (let i = 0; i < pics.length; i++) {
            this.images.push({ url: pics[i] })
          }

        } else {
          this.images = []
        }

        console.log(res);
        this.getLocation()
      })


    },
    getLocation () {
      let that = this;
      let geolocation = new qq.maps.Geolocation(
        'K33BZ-EG3KI-C5EG3-54ZFY-G7BB5-QWFS2',
        '假日伙伴-前端'
      )
      let container = document.getElementById("container")
      let geoloc = geolocation.getLocation(
        function (position) {
          console.log(position, 'position');
          let lat = position.lat;
          let lng = position.lng;
          let myLatlng = ''
          console.log('1111111');
          if (that.type == 'readonly') {
            myLatlng = new qq.maps.LatLng(that.latitude, that.longitude);
            console.log('到这里了', myLatlng);
          } else {
            myLatlng = new qq.maps.LatLng(lat, lng);
            console.log('新建', myLatlng);
          }

          //获取dom元素添加地图信息
          let map = new qq.maps.Map(
            container, {
            zoom: 18,
            center: myLatlng,
          }
          );
          let middleControl = document.createElement("div");
          middleControl.style.left = "50%";
          middleControl.style.top = "50%";
          middleControl.style.position = "relative";
          middleControl.style.width = "15px";
          middleControl.style.height = "15px";
          middleControl.style.zIndex = "100000";
          middleControl.innerHTML = `<image src="https://img.jiarixiaodui.com/jrhb/marker.png" />`;
          document.getElementById("container").appendChild(middleControl);
          //返回地图当前中心点地理坐标
          if (that.type === 'add') {
            that.latitude = map.getCenter().lat.toString()
            that.longitude = map.getCenter().lng.toString()
          }
          //当地图中心属性更改时触发事件

          qq.maps.event.addListener(map, 'center_changed', function () {
            if (that.type === 'add') {
              that.latitude = map.getCenter().lat.toString()
              that.longitude = map.getCenter().lng.toString()
            }

          });
        }
      )
      console.log('-------------------------------------------------------');

    },
    // 上传的回调
    afterRead (e) { },
    // 删除图片相关回调
    deleteImg (e) {
      console.log(e)
    },
    save () {
      let that = that
      this.loading = true
      let arr = []
      let tempArr = []
      for (let i = 0; i < this.images.length; i++) {
        let p = lrz(this.images[i].content, {
          width: 600,
          height: 600,
          quality: 0.75,
        })
          .then((res) => {
            arr.push(res.base64)

          })
          .catch((err) => {
            console.log(err)
          })

        tempArr.push(p)
      }
      Promise.all(tempArr).then(res => {
        let pics = arr
        this.$axios.post('/caidian/item-create', {
          caidian_id: this.artical_id,
          addr: this.addr,
          longitude: this.longitude,
          latitude: this.latitude,
          pics: pics,
          remark: this.remark
        }).then(res => {
          if (res.data.code != 200) {
            Toast(res.data.msg)
            this.loading = false
            return
          }
          this.$router.go(-1)

        }).catch(err => {
          Toast('网络异常,请稍后再试')
          this.loading = false
        })
      })
    },
  }

}
</script>
<style lang="scss" scoped>
.filds {
  border: 1px solid #f2f2f2;
  margin: 10px 20px;
}

.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  // justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
  z-index: 1000;

  .buttons {
    background-color: darkseagreen;
    width: 100%;
    padding: 10px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .buttons:active {
    background-color: burlywood;
  }
}
</style>